import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=1c4e04a7"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalTemplate.vue?vue&type=style&index=0&id=1c4e04a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports